import React, {Component} from 'react'
import {Dropdown} from 'semantic-ui-react'
import {getCompanyDocument} from '../firebase'

class Lista extends Component{
	constructor(props){
		super(props)
		this.state = {
			options: [],
		}
	}
	componentDidMount(){
		this.getData()
	}
	getData = async() => {
		const docRef = await getCompanyDocument()
		await docRef.get().then((doc) => {
			if (doc.exists) {
				const data = Array.isArray(doc.data().almacenes) ? doc.data().almacenes : [];
				const lista = []
				for(let i=0; i<data.length; i++){
					if(this.props.excluir && this.props.excluir === data[i]){
						console.log(data[i] + ' excluido')
					} else {
						lista.push({key:i, value:data[i], text:data[i]})
					}
				}
				this.setState({
					options:lista,
				}, () => {
					const currentValueIsValid = lista.some(option => option.value === this.props.value)
					if (!currentValueIsValid && lista.length && this.props.onChange) {
						this.props.onChange(null, {
							name: this.props.name,
							value: lista[0].value,
						})
					}
				})
			} else {
				console.log('La empresa no existe');
			}
		}).catch((error) => {
		console.log('Error al obtener los almacenes:', error);
	  });
	}
	render(){
		return (
			<Dropdown 
				placeholder='Seleccione Almacén'
				options={this.state.options}
				{...this.props}
			/>
		)
	}
}

export default Lista;
